module.exports = __webpack_public_path__ + "img/coreModule10.d39352c4.jpg";